import PlusIcon from '../../../../assets/icons/icon-projects-add-plus.svg?react'
import PlateLoader from '@/components/ui/Loader/PlateLoader'
import css from './WorkspaceProjectsNew.module.css'

interface WorkspaceProjectsNewProps {
    onClick?: () => void
    loading?: boolean
    atLimit?: boolean
}

const WorkspaceProjectsNew = ({ onClick, loading = false, atLimit = false }: WorkspaceProjectsNewProps) => {
    const className = loading ? `${css.container} ${css.loading}` : css.container
    const handleClick = loading ? undefined : onClick

    let content = <PlusIcon />
    if (loading) {
        content = <PlateLoader />
    } else if (atLimit) {
        content = (
            <>
                <PlusIcon />
                <span className={css.upgrade}>Upgrade</span>
            </>
        )
    }

    return (
        <div className={className} onClick={handleClick} data-testid="new-project-btn">
            <div className={css.icon}>
                {content}
            </div>
        </div>
    )
}

export default WorkspaceProjectsNew
